import {FC} from 'react'
import {useController, useFormContext} from 'react-hook-form'
import classNames from 'classnames'
import {SearchSelectBox} from 'jbc-front/components/SearchForm'
import styles from './SortingFields.scss'

interface Option {
  value: string
  label: string
}

interface SortingFieldsProps {
  limitName?: string
  limits: Option[]
  onChangeLimit?: (value: string) => void
  sortTypeName?: string
  sortTypes: Option[]
  onChangeSortType?: (value: string) => void
}

export const SortingFields: FC<SortingFieldsProps> = ({
  limitName = 'limit',
  limits,
  onChangeLimit,
  sortTypeName = 'sortType',
  sortTypes,
  onChangeSortType,
}) => {
  const {control} = useFormContext()

  const limitController = useController({name: limitName, control})
  const sortTypeController = useController({name: sortTypeName, control})

  const limitOnly = sortTypes.length === 0

  return (
    <div className={classNames(styles.sortingFields, limitOnly && styles.limitOnly)}>
      <SearchSelectBox
        input={{
          value: limitController.field.value as string,
          onChange: limitController.field.onChange,
          onBlur: limitController.field.onBlur,
        }}
        options={limits}
        width={110}
        onSelect={(newValue: string) => {
          onChangeLimit?.(newValue)
        }}
      />
      {!limitOnly && (
        <SearchSelectBox
          input={{
            value: sortTypeController.field.value as string,
            onChange: sortTypeController.field.onChange,
            onBlur: sortTypeController.field.onBlur,
          }}
          options={sortTypes}
          width={180}
          onSelect={(newValue: string) => {
            onChangeSortType?.(newValue)
          }}
        />
      )}
    </div>
  )
}
